var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10 8.73689 9.91276 8.97378 9.72574 9.1608L2.15772 16.7288C1.79615 17.0904 1.19769 17.0904 0.836118 16.7288C0.474549 16.3673 0.474549 15.7688 0.836119 15.4072L7.74334 8.5L0.836121 1.59278C0.474551 1.23121 0.474551 0.632746 0.836121 0.271177C1.19769 -0.0903924 1.79615 -0.0903924 2.15772 0.271177L9.72574 7.8392C9.91276 8.02622 10 8.26311 10 8.5Z",
    fill: "#0C1525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.85106e6c415072318f6a2e988d6b1be2.svg";
export { ForwardRef as ReactComponent };